import React from "react";

const Hero = () => {
  return (
    <section className="hero" id="technology">
      <div className="hero-background-video">
        <video autoPlay loop muted playsInline className="hero-bg-video">
          <source src="/images/ChocLead2.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="container hero-grid">
        <div className="hero-content">
          <p className="eyebrow">Plant based chocolate technology</p>
          <h1 className="hero-title">
            The world's first{" "}
            <span className="hero-highlight">true diet chocolate</span> for
            serious chocolatiers.
          </h1>
          <p className="hero-subtitle">
            There has never been a delicious solid chocolate available in milk and dark varieties that has the majority of the calories and net carbohydrates removed (and replaced with WATER and fibre), but keeps all the awesome taste... until now!
          </p>

          <div className="hero-ctas">
            <a href="#contact" className="btn primary-btn">
              Request samples
            </a>
            <a href="#benefits" className="btn secondary-btn">
              Explore how it works
            </a>
          </div>

          <div className="hero-metadata">
            <div className="hero-stat">
              <span className="hero-stat-label">Up to</span>
              <span className="hero-stat-value">53%</span>
              <span className="hero-stat-caption">
                fewer calories and net carbs per 100g
              </span>
            </div>

            <div className="hero-stat">
              <span className="hero-stat-label">100%</span>
              <span className="hero-stat-caption">
                plant based, non GMO and free from artificial sweeteners
              </span>
            </div>

            <div className="hero-stat">
              <span className="hero-stat-label">US patent</span>
              <span className="hero-stat-caption">
                fibre plus water chocolate process, patent 11882848
              </span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-card">
            <div className="hero-chip">For professional chocolatiers</div>

            <div className="hero-image-frame">
              <video
                autoPlay
                loop
                muted
                playsInline
                src="/images/hero.mp4"
              >
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="hero-mini-grid">
              <div className="hero-mini-card">
                <p className="mini-label">Calories displaced</p>
                <p className="mini-value">up to 53%+</p>
              </div>
              <div className="hero-mini-card">
                <p className="mini-label">Formats</p>
                <p className="mini-value">Milk and dark</p>
              </div>
              <div className="hero-mini-card">
                <p className="mini-label">Applications</p>
                <p className="mini-value">Bars, inclusions, coatings</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
